<template>
    <div class="login-root" @click="nation.show = false">
        <Top></Top>
        <div class="login-body___1UbSf">
            <div class="page_login___3Uiai">
                <!--<div style="overflow: hidden;">
                    <div class="cmptPop___3wEG9 bg1"></div>
                    <div class="cmptPop___3wEG9 bg2"></div>
                    <div class="cmptPop___3wEG9 bg3"></div>
                    <div class="cmptPop___3wEG9 bg4"></div>
                    <div class="cmptPop___3wEG9 bg5"></div>
                    <div class="cmptPop___3wEG9 bg6"></div>
                    <div class="cmptPop___3wEG9 bg7"></div>
                    <div class="cmptPop___3wEG9 bg8"></div>
                    <div class="cmptPop___3wEG9 bg9"></div>
                    <div class="cmptPop___3wEG9 bg10"></div>
                    <div class="cmptPop___3wEG9 bg11"></div>
                    <div class="cmptPop___3wEG9 bg12"></div>
                    <div class="cmptPop___3wEG9 bg13"></div>
                    <div class="cmptPop___3wEG9 bg14"></div>
                </div>-->
                <div class="box_container___2ARHO">
                    <div>
                        <div class="section___Hbw51 future___1T4vA" v-if="!nextShow">
                            <div class="rl_box___1uBz1">
                                <form class="ant-form ant-form-horizontal">
                                    <div class="rl_head___2TvSx">
                                        <h1 class="rl_head_title___IZmSr">{{ $t('m.login.forget.title') }}</h1>
                                        <div class="flex___1UqB6 rl_head_type_cnt___260He">
                                            <span class="rl_head_type___lOeFa"
                                                  :class="forget.type == 'mobile' ? 'active___iY9Zp' : ''"
                                                  @click="forget.type = 'mobile'">{{ $t('m.login.login.change[1]') }}</span>
                                            <div class="ant-divider ant-divider-vertical"></div>
                                            <span class="rl_head_type___lOeFa"
                                                  :class="forget.type == 'email' ? 'active___iY9Zp' : ''"
                                                  @click="forget.type = 'email'">{{ $t('m.login.login.change[0]') }}</span>
                                        </div>
                                    </div>
                                    <div class="rl_body___EZT9G" v-if="forget.type == 'email'">
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <div>
                                                        <input type="text" class="ant-input kc-input"
                                                               :placeholder="$t('m.login.login.change[0]')"
                                                               v-model="forget.email">
                                                    </div>
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g ">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div>
                                                            <span class="ant-input-group-wrapper">
                                                                <span class="ant-input-wrapper ant-input-group">
                                                                    <span class="ant-input-group-addon"
                                                                          @click="getCode()">
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;"
                                                                              v-if="expire.show == 0">{{ $t('m.login.register.text[0]') }}</span>
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;"
                                                                              v-else-if="expire.show == 2">{{ $t('m.login.register.text[1]') }}</span>
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;" v-else>{{ expire.time }}</span>
                                                                    </span>
                                                                    <input type="text"
                                                                           class="ant-input kc-input kc-input-send"
                                                                           :placeholder="$t('m.login.register.text[2]')"
                                                                           v-model="forget.note">
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g"
                                             style="margin-bottom: 8px;">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="ant-btn rl_btn___2osxC kc-button ant-btn-primary"
                                                             style="width: 100%; height: 36px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
                                                             @click="nextStepEmail()">
                                                            <span>{{ $t('m.login.forget.text[0]') }}</span>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="tips___28YHZ flex___1UqB6"
                                                             style="justify-content: space-between;">
                                                            <span></span>
                                                            <div class="pointer" @click="changeRoute('/login')">{{ $t('m.login.forget.text[1]') }}</div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rl_body___EZT9G" v-else>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper"
                                                 @click.stop="nation.show = !nation.show">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <div class="select_country___3qk6_ kc-select  ant-select ant-select-enabled">
                                                        <div class="ant-select-selection ant-select-selection--single">
                                                            <div class="ant-select-selection__rendered"
                                                                 v-if="!nation.active">
                                                                <div class="ant-select-selection__placeholder"
                                                                     style="display: block; user-select: none;">
                                                                    <img src="@/assets/img/sousuo.png" alt="">
                                                                    <span>{{ $t('m.login.login.text[2]') }}</span>
                                                                </div>
                                                            </div>
                                                            <span class="ant-select-arrow" style="user-select: none;">
                                                                <i class="ant-select-arrow-icon"></i>
                                                            </span>
                                                        </div>
                                                        <div class="nation-list-active" v-if="nation.active">
                                                            <div>
                                                                <img src=@/assets/img/china.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[0]')">
                                                                <img src=@/assets/img/china.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[9]')">
                                                                <img src=@/assets/img/china.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[10]')">
                                                                <img src=@/assets/img/winerbit/korea.jpg
                                                                     v-show="nation.name == $t('m.login.login.nation[11]')">
                                                                <img src=@/assets/img/winerbit/japan.jpg
                                                                     v-show="nation.name == $t('m.login.login.nation[12]')">
                                                                <img src=@/assets/img/winerbit/myanmar.jpg
                                                                     v-show="nation.name == $t('m.login.login.nation[13]')">
                                                                <img src=@/assets/img/canada.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[1]')">
                                                                <img src=@/assets/img/usa.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[2]')">
                                                                <img src=@/assets/img/india.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[3]')">
                                                                <img src=@/assets/img/indonesia.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[4]')">
                                                                <img src=@/assets/img/turkey.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[5]')">
                                                                <img src=@/assets/img/united-kingdom.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[6]')">
                                                                <img src=@/assets/img/philippines.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[7]')">
                                                                <img src=@/assets/img/thailand.svg
                                                                     v-show="nation.name == $t('m.login.login.nation[8]')">
                                                            </div>
                                                            <div>{{ nation.name }}</div>
                                                            <div>+{{ nation.code }}</div>
                                                        </div>
                                                    </div>
                                                </span>
                                                </div>
                                            </div>
                                            <div class="nation-container" v-if="nation.show">
                                                <div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[0]'),'86')">
                                                        <div><img src="@/assets/img/china.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[0]') }}</div>
                                                        <div>+86</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[9]'),'852')">
                                                        <div><img src="@/assets/img/china.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[9]') }}</div>
                                                        <div>+852</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[10]'),'886')">
                                                        <div><img src="@/assets/img/china.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[10]') }}</div>
                                                        <div>+886</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[11]'),'82')">
                                                        <div><img src="@/assets/img/winerbit/korea.jpg"></div>
                                                        <div>{{ $t('m.login.login.nation[11]') }}</div>
                                                        <div>+82</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[12]'),'81')">
                                                        <div><img src="@/assets/img/winerbit/japan.jpg"></div>
                                                        <div>{{ $t('m.login.login.nation[12]') }}</div>
                                                        <div>+81</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[13]'),'95')">
                                                        <div><img src="@/assets/img/winerbit/myanmar.jpg"></div>
                                                        <div>{{ $t('m.login.login.nation[13]') }}</div>
                                                        <div>+95</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[1]'),'1')">
                                                        <div><img src="@/assets/img/canada.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[1]') }}</div>
                                                        <div>+1</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[2]'),'1')">
                                                        <div><img src="@/assets/img/usa.svg" alt=""></div>
                                                        <div>{{ $t('m.login.login.nation[2]') }}</div>
                                                        <div>+1</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[3]'),'91')">
                                                        <div><img src="@/assets/img/india.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[3]') }}</div>
                                                        <div>+91</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[4]'),'62')">
                                                        <div><img src="@/assets/img/indonesia.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[4]') }}</div>
                                                        <div>+62</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[5]'),'90')">
                                                        <div><img src="@/assets/img/turkey.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[5]') }}</div>
                                                        <div>+90</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[6]'),'44')">
                                                        <div><img src="@/assets/img/united-kingdom.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[6]') }}</div>
                                                        <div>+44</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[7]'),'63')">
                                                        <div><img src="@/assets/img/philippines.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[7]') }}</div>
                                                        <div>+63</div>
                                                    </div>
                                                    <div class="nation-list"
                                                         @click="nationCheck($t('m.login.login.nation[8]'),'66')">
                                                        <div><img src="@/assets/img/thailand.svg"></div>
                                                        <div>{{ $t('m.login.login.nation[8]') }}</div>
                                                        <div>+66</div>
                                                    </div>
                                                </div>
                                                <div class="nation-more">{{ $t('m.login.login.text[3]') }}</div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <div>
                                                        <input type="text" class="ant-input kc-input"
                                                               :placeholder="$t('m.login.login.text[1]')"
                                                               v-model="forget.mobile">
                                                    </div>
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g ">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div>
                                                            <span class="ant-input-group-wrapper">
                                                                <span class="ant-input-wrapper ant-input-group">
                                                                    <span class="ant-input-group-addon"
                                                                          @click="getNote()">
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;"
                                                                              v-if="expireOther.show == 0">{{ $t('m.login.register.text[0]') }}</span>
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;"
                                                                              v-else-if="expireOther.show == 2">{{ $t('m.login.register.text[1]') }}</span>
                                                                        <span class="sendBtn___1K2yT"
                                                                              style="pointer-events: all;" v-else>{{ expireOther.time }}</span>
                                                                    </span>
                                                                    <input type="text"
                                                                           class="ant-input kc-input kc-input-send"
                                                                           :placeholder="$t('m.login.register.text[9]')"
                                                                           v-model="forget.code">
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g"
                                             style="margin-bottom: 8px;">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="ant-btn rl_btn___2osxC kc-button ant-btn-primary"
                                                             style="width: 100%; height: 36px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
                                                             @click="nextStep()">
                                                            <span>{{ $t('m.login.forget.text[0]') }}</span>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                    <span class="ant-form-item-children">
                                                        <div class="tips___28YHZ flex___1UqB6"
                                                             style="justify-content: space-between;">
                                                            <span></span>
                                                            <div class="pointer" @click="changeRoute('/login')">{{ $t('m.login.forget.text[1]') }}</div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="section___Hbw51 future___1T4vA" v-if="nextShow">
                            <div class="rl_box___1uBz1 rl_box_spec___OCoRK">
                                <form class="ant-form ant-form-horizontal">
                                    <div class="rl_head___2TvSx flex_center___wTh7x">
                                        <h1 class="rl_head_title___IZmSr ">{{ $t('m.login.register.text[7]') }}</h1>
                                    </div>
                                    <div class="rl_body___EZT9G">
                                        <div class="ant-row ant-form-item passwordWithBar___26hsC rl_body_row___Pma1g" style="position: relative">
                                            <div class="ant-form-item-label">
                                                <label for="password" class="ant-form-item-required">pwd</label>
                                            </div>
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <input type="password" class="ant-input kc-input" id="password"
                                                           :placeholder="$t('m.login.login.pwd[0]')"
                                                           v-model="forget.pwd">
                                                </span>
                                                </div>
                                            </div>
                                            <div style="height: 24px;line-height:24px;font-size: 12px;color: #1C85CF;padding-left: 12px;position: absolute;top: 36px">{{ $t('m.login.register.pwd[6]') }}</div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <input type="password" class="ant-input kc-input"
                                                           :placeholder="$t('m.login.register.pwd[0]')"
                                                           v-model="forget.rePwd">
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ant-row ant-form-item rl_body_row___Pma1g">
                                            <div class="ant-form-item-control-wrapper">
                                                <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <button type="button"
                                                            class="ant-btn rl_btn___2osxC kc-button ant-btn-primary"
                                                            style="width: 100%;height: 36px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
                                                            @click="judgeForget()">
                                                        <span>{{ $t('m.login.forget.text[2]') }}</span>
                                                    </button>
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="commonCaptcha___3gFCP"></div>
            </div>
        </div>
        <div class="login-slide-verify" v-show="verifyShow">
            <slide-verify
                    :l="42"
                    :r="10"
                    :w="310"
                    :h="155"
                    @success="onSuccess"
                    @fail="onFail"
                    ref="slideblock"
                    @refresh="onRefresh"
                    :slider-text="text">
            </slide-verify>
        </div>
        <div class="login-bg" v-show="verifyShow" @click="verifyShow = false"></div>
    </div>
</template>

<script>
    import Top from '@/components/top';
    import gt from '../../assets/js/gt'

    export default {
        name: "forget",
        components: {
            Top
        },
        data() {
            return {
                nextShow: false,
                nation: {
                    name: "",
                    code: "",
                    show: false,
                    active: false
                },
                forget: {
                    mobile: "",
                    email: "",
                    pwd: '',
                    rePwd: '',
                    code: '',
                    nationality: '',
                    type: "mobile",
                    note: ''
                },
                expire: {
                    show: 0, //0为发送，1发送成功，2发送中
                    time: 60
                },
                expireOther: {
                    show: 0, //0为发送，1发送成功，2发送中
                    time: 60
                },
                forgetObj: {},
                text:'向右拖动滑块填充拼图',
                verifyShow: false
            }
        },
        mounted() {
            this.text = this.$t('m.login.login.text')[7];
        },
        methods: {
            onSuccess() {
                this.complete(this.forgetObj);
            },
            onFail() {
                this.onRefresh();
            },
            onRefresh() {
                console.log('按钮刷新的回调')
            },

            /*init() {
                let th = this;
                th.$axios.get(th.requestConfig.host + '/index/user/gt').then((res) => {
                    initGeetest({
                        gt: res.data.gt,
                        challenge: res.data.challenge,
                        offline: !res.data.success,
                        new_captcha: true,
                        // 省略必须的配置参数
                        product: 'bind',
                        width: '100%',
                        lang: localStorage.getItem('lang') == 'zh-CN' ? 'zh-cn' : 'en'
                    }, function (captchaObj) {

                        document.getElementById('isForget').addEventListener('click', function () {
                            if (th.judgeForget() != false) {
                                captchaObj.verify();
                            }
                        });
                        captchaObj.onReady(function () {
                        }).onSuccess(function () {
                            th.complete(th.forgetObj)
                        }).onError((err) => {
                            console.error(err)
                        })
                    })
                })
            },*/
            nationCheck: function (name, code) {
                this.nation.name = name;
                this.nation.code = code;
                this.nation.show = false;
                this.nation.active = true;
            },
            getCode: function () {
                if (this.expire.show) return;
                if (this.forget.email == '') {
                    this.$message.error(this.$t('m.common.register[0]'));
                    return;
                }
                this.expire.show = 2;
                  let paramData = {
                    email: this.forget.email,
                    type : 2
                  };
                  paramData.signature = this.signature(paramData);
                  this.$axios.post(this.requestConfig.host + "/index/Login/noteEmail", paramData).then((res) => {
                    res.cbkE = () => this.expire.show = 0;
                    return this.checkResponse(res);
                }).then((res) => {
                    this.expire = {
                        show: 1,
                        time: 60
                    };
                    let it = setInterval(() => {
                        if (this.expire.time >= 1) {
                            this.expire.time--;
                        } else {
                            clearInterval(it);
                            this.expire.show = false;
                        }
                    }, 1000);
                }).then((res) => {
                    this.$message.success(this.$t('m.common.register[1]'));
                }).catch((e) => {

                })
            },
            nextStepEmail: function () {
                if (this.forget.email == '') {
                    this.$message.error(this.$t('m.common.register[0]'));
                    return;
                }
                let paramData =   this.signRequest({
                  note: this.forget.note,
                  email: this.forget.email,
                  type: 2
                });
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/checkNote",paramData).then((res) => {
                    return this.checkResponse(res);
                }).then(() => {
                    this.nextShow = true;
                    // this.init();
                }).catch((e) => {
                    if (e == 20001) return;
                    // this.aMyAlert({show: true, msg: e});
                    this.$message.error(e);
                })
            },
            // 获取手机短信验证码
            getNote: function () {
                if (this.expireOther.show) return;
                this.expireOther.show = 2;
                if (this.forget.mobile == '') {
                    this.$message.error(this.$t('m.common.my.mobile[2]'));
                    this.expireOther.show = 0;
                    return;
                }
                let paramData =  {
                  nationality: Number(this.nation.code),
                  mobile: this.forget.mobile,
                  type: 2
                };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/sendSms",paramData).then((res) => {
                    res.cbkE = () => this.expireOther.show = 0;
                    return this.checkResponse(res);
                }).then((res) => {
                    this.expireOther = {
                        show: 1,
                        time: 60
                    };
                    let it = setInterval(() => {
                        if (this.expireOther.time >= 1) {
                            this.expireOther.time--;
                        } else {
                            clearInterval(it);
                            this.expireOther.show = false;
                        }
                    }, 1000);
                }).then((res) => {
                    this.$message.success(this.$t('m.common.my.mobile[0]'));
                }).catch((e) => {
                    this.$message.error(e);
                })
            },
            nextStep: function () {
                if (this.forget.mobile == '') {
                    this.$message.error(this.$t('m.common.register[12]'));
                    return;
                }
                if (this.forget.code == '') {
                    this.$message.error(this.$t('m.common.register[2]'));
                    return;
                }
                let paramData =  {
                  mobile: this.forget.mobile,
                  code: this.forget.code,
                  type: 2
                };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/checkCode", paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.nextShow = true;
                    // this.init();
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    // this.aMyAlert({show: true, msg: e});
                    this.$message.error(e);
                })
            },
            complete(obj) {
                this.onRefresh();
                // 2.验证登录
                this.$axios.post(this.requestConfig.host + "/index/Login/pwdResetByNote", obj).then((res) => {
                    if(res.data.error_code != 200){
                      this.$refs.slideblock.reset();
                      this.verifyShow = false;
                    }
                    return this.checkResponse(res);
                }).then(() => {
                    /*this.aSuccess({
                        show: true,
                        tip: this.$t('m.common.forget[3]'),
                    });*/
                    this.$message.success(this.$t('m.common.forget[3]'));
                    setTimeout(() => {
                        this.changeRoute("/login")
                    }, 800);
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    /*this.aMyAlert({
                        show: true,
                        msg: this.$t('m.common.forget[4]')
                    });*/
                    this.$message.error(this.$t('m.common.forget[4]'));
                })
            },
            judgeForget() {
                // 1.验证前后密码是否一致
                if (this.forget.pwd == "") {
                    // this.aMyAlert({show: true, msg: this.$t('m.common.forget[0]')});
                    this.$message.error(this.$t('m.common.forget[0]'));
                    return false;
                }
                if (this.forget.pwd.length < 8) {
                    // this.aMyAlert({show: true, msg: this.$t('m.common.forget[1]')});
                    this.$message.error(this.$t('m.common.forget[1]'));
                    return false;
                }
                let reg = /^(?=.*[a-z])[a-z0-9]+/ig;
                if (reg.test(this.forget.pwd) == false) {
                    this.$message.error(this.$t('m.common.register[16]'));
                    return;
                }
                if (this.forget.pwd != this.forget.rePwd) {
                    // this.aMyAlert({show: true, msg: this.$t('m.common.forget[2]')});
                    this.$message.error(this.$t('m.common.forget[2]'));
                    return false;
                }

                // 判断找回密码类型
                if (this.forget.type == 'email') {
                    // 如果是邮箱
                    this.forgetObj = {
                        account: this.forget.email,
                        pwd: this.forget.pwd,
                        enum: 1,
                        note: this.forget.note
                    };
                } else {
                    // 如果是手机
                    this.forgetObj = {
                        nationality: Number(this.nation.code),
                        account: this.forget.mobile,
                        pwd: this.forget.pwd,
                        enum: 2,
                        note: this.forget.code
                    };
                }
                this.forgetObj.signature = this.signature(this.forgetObj);
                this.verifyShow = true;
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/register.css";
</style>
